import moment from "jalali-moment";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";

function Footer() {
  const { t } = useTranslation();
  return (
    <Grid
      container
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      sx={({ breakpoints }) => ({
        position: "absolute",
        bottom: -30,

        [breakpoints.down("sm")]: {
          bottom: -80,
          width: "inherit"
        },
      })}
    >
      <Grid item>
        <MDTypography color="text" fontSize="sm">
          {t("headings.footer")}
        </MDTypography>
      </Grid>
      <Grid item mr={8}>
        <MDTypography color="text" fontSize="sm">
          {t("headings.today")}
          <MDTypography component="span" fontSize="sm" fontWeight="bold" mx={1}>
            {moment(new Date()).locale("fa").format("dddd")}
          </MDTypography>
          <MDTypography component="span" fontSize="sm">
            {moment(new Date()).locale("fa").format("YYYY/MM/DD")}
          </MDTypography>
        </MDTypography>
      </Grid>
    </Grid>
  );
}

export default Footer;
